/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 1:12 PM
 *
 */

import React from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'stores';
import { toggleOpen } from 'stores/slices/sideBarSlice';

import { RouteObjectType } from 'components/layout/Sidebar/sidebarRoutes';

type NavItemProps = {
  route: RouteObjectType;
  containerClassName?: string;
};

const NavItem = ({ route, containerClassName }: NavItemProps) => {
  const open = useAppSelector((state) => state.sidebar.open);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeStyles =
    'font-medium text-gray-900  bg-gray-100 relative py-2.5 rounded-lg cursor-pointer hover:bg-gray-200 ';
  const inactiveStyles =
    'font-medium text-gray-500 hover:text-gray-900 relative py-2.5 rounded-lg cursor-pointer hover:bg-gray-50   ';

  return (
    <div className={containerClassName}>
      <li
        className={route.link && pathname.includes(route.link) ? activeStyles : inactiveStyles}
        onClick={() => {
          if (route.link) {
            navigate(route.link);
            isMobile && dispatch(toggleOpen());
          }
        }}
      >
        <div className="peer flex">
          <div
            className={`relative flex items-start justify-start px-4  ${
              open ? 'translate-x-0' : 'w-0 -translate-x-96 p-0 '
            } transition-all duration-100 `}
          >
            <span className="flex items-center gap-x-4 text-lg">
              <div>{route.icon}</div>

              <span className="line-clamp-1 sm:text-lg">{route.title}</span>
            </span>
          </div>

          <div
            className={`relative flex items-center sm:hidden ${
              !open
                ? '-translate-x-8 px-4 opacity-100 transition-opacity  duration-500 '
                : 'w-0 p-0 opacity-0'
            }  `}
          >
            <div className="sm:hidden">{route.icon}</div>
          </div>
        </div>

        {!open && (
          <div className="pointer-events-none absolute top-0 left-[150%] z-0 flex h-10 w-0 translate-y-1/4 items-center justify-center rounded-md bg-gray-800 text-lg font-normal text-gray-50 opacity-0 shadow-E200 transition-all duration-300 peer-hover:w-36 peer-hover:opacity-100">
            {route.title}
          </div>
        )}
      </li>
    </div>
  );
};

export default NavItem;
